import React from "react";
import {Card} from "@euroland/base-ui";
import VictorShowMultipleItems from "./VictorShowMultipleItems";
import VictorShowSingleItem from "./VictorShowSingleItem";
import useHistoricalShares from "../../hooks/useHistoricalShares";
import { useFormatSetting } from "../../hooks/useCompanySettings";
import { formatDate } from "@euroland/libs";
import { DATE_SCREEN_READER } from "../../constant/common";

const VictorViewHistory = ({ onClose }) => {
  const {
    historicalShares: { historicalShareList },
  } = useHistoricalShares();
  const formatSettings = useFormatSetting();
  const firstHistoricalShare = historicalShareList?.[0] || {};

  return (
    <Card
      label={formatDate(firstHistoricalShare.date, "shortDate")}
      ariaLabel={formatDate(firstHistoricalShare.date, "", DATE_SCREEN_READER)}
      //  label="Friday, September 23, 2022"
      className="animationAppear"
      onClose={onClose}
    >
      {/* <ShowSingleItem /> */}
      {historicalShareList?.length > 1 ? (
        <VictorShowMultipleItems historicalShareList={historicalShareList} formatSettings={formatSettings} />
      ) : (
        <VictorShowSingleItem historicalShareList={firstHistoricalShare} formatSettings={formatSettings} />
      )}
    </Card>
  );
};

export default VictorViewHistory;
